import React from "react";

const Stat_Certificate = () => {
  return (
    <div>
      <h1>Stat Certificate</h1>
    </div>
  );
};

export default Stat_Certificate;
